import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MenuBuilder } from '@/components/menu/MenuBuilder';
import useRestaurantStore from '@/lib/stores/restaurantStore';
import { ROUTES } from '@/types';

/**
 * MenuBuilderPage - Page wrapper for the menu builder
 * Handles routing and restaurant context
 */
const MenuBuilderPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { restaurants } = useRestaurantStore();

  const restaurant = restaurants.find(r => r.id === id);

  // Redirect if restaurant not found
  if (!restaurant) {
    navigate(ROUTES.RESTAURANTS);
    return null;
  }

  const handleBack = () => {
    navigate(ROUTES.RESTAURANTS);
  };

  return (
    <MenuBuilder
      restaurant={restaurant}
      onBack={handleBack}
    />
  );
};

export default MenuBuilderPage;